//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '500px'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handelClose: function handelClose() {
      this.$emit('handelClose');
    },
    handelSubmit: function handelSubmit() {
      this.$emit('handelDialogSubmit');
    }
  }
};